/**
 * Formats a string to a hyphenated string.
 * @param {string} str - The string to hyphenate.
 * @returns {string} The hyphenated string.
 */
export const hyphenate = (str) =>
	str
		.trim()
		.toLocaleLowerCase()
		.replace(/\s+/g, '-')
		.replace(/-+/g, '-')
		.replace(/^-+|-+$/g, '');
